import useStepper from "../hooks/useStepper";

const withStepper = (Component: React.ComponentType<any>) => {
  return ({ slide, totalSlides, ...props }: { slide: number; totalSlides: number }) => {
    return <Component slide={slide} totalSlides={totalSlides} {...props} />;
  };
};

export default withStepper;
